import React, { Component } from 'react';
import Viewer from '../../helpers/documentViewer';
import '../../content/css/ContractReviewer.css';

export default class HighlightMarkers extends Component {

    componentDidMount() {
        Viewer.updateMarkersHOCR(document, this.props.selectedHighlight);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.lastUpdate !== prevProps.lastUpdate) {
            Viewer.updateMarkersHOCR(document, this.props.selectedHighlight);
        }

        if (this.props.selectedHighlight !== prevProps.selectedHighlight && this.props.lastUpdate !== 0) {
            Viewer.updateMarkersHOCR(document, this.props.selectedHighlight);
        }
    }

   
    getMarkers() {
        var self = this;
        return this.props.highlights.map((p, i) => (
            <div data-id={i} className={`marker fixed risk-${p.risk}${p.isActive ? "" : " disabled"}`} key={i} onClick={() => self.props.onItemClick(p, i)} />
        ));
    }

    render() {
        return (
            <div className="wild-marker-list" id="wild-marker-list">
                {this.getMarkers()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Highlight/HighlightMarkers.js